const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/messages.ts';
import { IActionHandlersMap, KisApiAction, makeReducer } from '@cistec/common_web/defs/actionTypes';
import { addRequestActionHandlers, getData, useRemoteData2 } from '@cistec/common_web/utils/redux4Requests';
import { loadMessages, REQUEST_ACTION_TYPES_MESSAGES } from 'App/actions/message';
import { MetaKatTranslations } from 'App/defs/types';
import { PatAppStoreState } from './setup/rootReducer';

export interface Message {
    ICODE: string;
    FKEY: string;
    translations: MetaKatTranslations;
    status: 'info' | 'success' | 'danger' | 'warning' | 'caution';
}

const handlers: IActionHandlersMap = {};

const messagesMapper = (action: KisApiAction) => {
    return action.payload.map((item: any): Message => {
        const { DE, EN, FR, IT, Status } = item.CONTENT;
        return {
            ICODE: item.ICODE,
            FKEY: item.FKEY,
            status: Status,
            translations: {
                DE,
                EN,
                FR,
                IT,
            },
        };
    });
};

addRequestActionHandlers(handlers, REQUEST_ACTION_TYPES_MESSAGES, undefined, messagesMapper);

export const messagesReducer = makeReducer(handlers);

// SELECTORS

const selectMessages = (state: PatAppStoreState): Message[] | undefined => getData(state.messages);

// HOOKS

export function useMessages() {
    return useRemoteData2('messages', {
        request: dispatch => dispatch(loadMessages()),
        select: selectMessages,
    });
}
